import Component from '@glimmer/component';
import DefinitionList from '../../../ui/definition-list.gts';
import { divide } from 'tio-ui/math';
import safeFormatNumber from '../../../../helpers/safe-format-number.ts';
import type { CalculationInputs } from './calculations-readonly-card.ts';
import type { TasClaimsFinancials } from '../../../../types/tuition-assistance.ts';

export interface ClaimsFinancialsCalculationsSectionSignature {
  Args: {
    claimsFinancialsFields: Readonly<TasClaimsFinancials>;
    lineItems: CalculationInputs[];
    sectionHeading: string;
  };
  Element: HTMLElement;
}

export default class ClaimsFinancialsCalculationsSection extends Component<ClaimsFinancialsCalculationsSectionSignature> {
  setValue = (key: keyof TasClaimsFinancials) => {
    return this.args.claimsFinancialsFields[key];
  };

  <template>
    <div ...attributes>
      <h3 class="font-semibold mb-2 tio-fg-secondary uppercase">
        {{@sectionHeading}}
      </h3>
      <DefinitionList as |options|>
        {{#each @lineItems as |lineItem|}}
          <div class={{options.wrappingClass}}>
            <options.dt class="text-balance">
              {{lineItem.label}}
            </options.dt>
            {{#if (eq lineItem.type "currency")}}
              <options.dd class="font-semibold">
                {{safeFormatNumber
                  (divide (this.setValue lineItem.dataKey) 100)
                  style="currency"
                  currency="USD"
                }}
              </options.dd>
            {{else if (eq lineItem.type "percent")}}
              <options.dd class="font-semibold">
                {{safeFormatNumber (this.setValue lineItem.dataKey) style="percent"}}
              </options.dd>
            {{/if}}
          </div>
        {{/each}}
      </DefinitionList>
    </div>
  </template>
}
